import React from 'react';
import PropTypes from 'prop-types';
import './modal.scss';

// Basic modal component with customizable content and close functionality
const BasicModal = ({ isOpen = false, onClose = true, children = {} }) => {
    // If the modal is not open, return null to render nothing
    if (!isOpen) return;
    return (
        // Modal container with overlay and content
        <div className="modal">
            <div className="modal-content">
                {/* Close button for the modal */}
                <span className="close" onClick={onClose} aria-label="Close dialog">
                    <svg className="tv-icon close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" style={{
                        width: 45,
                        height: 45,
                    }}>
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                </span>
                {/* Render children inside the modal */}
                {children}
            </div>
        </div>
    );
};

BasicModal.propTypes = {
    children: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default BasicModal;
